import { Activity, type FC } from 'react';

import { EventsFilter } from '@/features/geo-area/components/region/EventsFilter';
import { RadiusFilter } from '@/features/geo-area/components/region/RadiusFilter';
import {
  RegionTab,
  type RegionFilterChange
} from '@/features/geo-area/components/region/regionTypes';

export const ActiveRegionFilter: FC<{
  activeTab: RegionTab;
  onChange: (change: RegionFilterChange) => void;
}> = ({ activeTab, onChange }) => (
  <>
    <Activity
      mode={
        activeTab === RegionTab.REGIONAL_RADIO ||
        activeTab === RegionTab.EMERGENCY
          ? 'visible'
          : 'hidden'
      }
    >
      <RadiusFilter />
    </Activity>
    <Activity mode={activeTab === RegionTab.EVENTS ? 'visible' : 'hidden'}>
      <EventsFilter onChange={onChange} />
    </Activity>
  </>
);
